// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__13weW","header":"ReportDetails_header__10PqV","title":"ReportDetails_title__2glWq","left":"ReportDetails_left__2N8WM"};